import React from "react";
import { Image, Platform } from "react-native";

let pictures;
if (Platform.OS === "web") {
  pictures = {
    bed: require(`../../resources/icons/categories/web/bed.svg`),
    children: require(`../../resources/icons/categories/web/children.svg`),
    curtain: require(`../../resources/icons/categories/web/curtain.svg`),
    home: require(`../../resources/icons/categories/web/home.svg`),
    jackets: require(`../../resources/icons/categories/web/jackets.svg`),
    men: require(`../../resources/icons/categories/web/men.svg`),
    misc: require(`../../resources/icons/categories/web/misc.svg`),
    shoes: require(`../../resources/icons/categories/web/shoes.svg`),
    women: require(`../../resources/icons/categories/web/women.svg`),
    wash: require(`../../resources/icons/products/web/wash.svg`),
    iron: require(`../../resources/icons/products/web/iron.svg`),
    stainRemover: require(`../../resources/icons/products/web/stainRemover.svg`),
    tailoring: require(`../../resources/icons/tailoring.svg`),
    minus: require(`../../resources/icons/products/web/minus.svg`),
    minusDisabled: require(`../../resources/icons/products/web/minusDisabled.svg`),
    add: require(`../../resources/icons/products/web/add.svg`),
    addDisabled: require(`../../resources/icons/products/web/addDisabled.svg`),
    serverError: require(`../../resources/icons/errors/web/serverError.svg`),
    ordersEmpty: require(`../../resources/icons/errors/web/ordersEmpty.svg`),
    gloves: require(`../../resources/icons/products/web/gloves.svg`),
    hat: require(`../../resources/icons/products/web/hat.svg`),
    socks: require(`../../resources/icons/products/web/socks.svg`),
    shawl: require(`../../resources/icons/products/web/shawl.svg`),
    pray: require(`../../resources/icons/products/web/pray.svg`),
    cloak: require(`../../resources/icons/products/web/cloak.svg`),
    canopy: require(`../../resources/icons/products/web/canopy.svg`),
    carCover: require(`../../resources/icons/products/web/carCover.svg`),
    childClothes: require(`../../resources/icons/products/web/childClothes.svg`),
    doll: require(`../../resources/icons/products/web/doll.svg`),
    babyShoes: require(`../../resources/icons/products/web/babyShoes.svg`),
    carriage: require(`../../resources/icons/products/web/carriage.svg`),
    babySeat: require(`../../resources/icons/products/web/babySeat.svg`),
    babyClothes: require(`../../resources/icons/products/web/babyClothes.svg`),
    skiJacket: require(`../../resources/icons/products/web/skiJacket.svg`),
    jacket: require(`../../resources/icons/products/web/jacket.svg`),
    coat: require(`../../resources/icons/products/web/coat.svg`),
    featherJacket: require(`../../resources/icons/products/web/featherJacket.svg`),
    overcoat: require(`../../resources/icons/products/web/overcoat.svg`),
    skipants: require(`../../resources/icons/products/web/skipants.svg`),
    rainCoat: require(`../../resources/icons/products/web/rainCoat.svg`),
    pullOver: require(`../../resources/icons/products/web/pullOver.svg`),
    sweatShirt: require(`../../resources/icons/products/web/sweatShirt.svg`),
    cushion: require(`../../resources/icons/products/web/cushion.svg`),
    carpet: require(`../../resources/icons/products/web/carpet.svg`),
    lampshade: require(`../../resources/icons/products/web/lampshade.svg`),
    tableclothes: require(`../../resources/icons/products/web/tableclothes.svg`),
    mat: require(`../../resources/icons/products/web/mat.svg`),
    mattress: require(`../../resources/icons/products/web/mattress.svg`),
    blanket: require(`../../resources/icons/products/web/blanket.svg`),
    cover: require(`../../resources/icons/products/web/cover.svg`),
    eiderdown: require(`../../resources/icons/products/web/eiderdown.svg`),
    pillow: require(`../../resources/icons/products/web/pillow.svg`),
    pillowCover: require(`../../resources/icons/products/web/pillowCover.svg`),
    bathrobes: require(`../../resources/icons/products/web/bathrobes.svg`),
    sleepingBag: require(`../../resources/icons/products/web/sleepingBag.svg`),
    towel: require(`../../resources/icons/products/web/towel.svg`),
    shoes2: require(`../../resources/icons/products/web/shoes2.svg`),
    semmershoes: require(`../../resources/icons/products/web/semmershoes.svg`),
    boot: require(`../../resources/icons/products/web/boot.svg`),
    leatherShoes: require(`../../resources/icons/products/web/leatherShoes.svg`),
    backPack: require(`../../resources/icons/products/web/backPack.svg`),
    bag: require(`../../resources/icons/products/web/bag.svg`),
    loggage: require(`../../resources/icons/products/web/loggage.svg`),
    menBluze: require(`../../resources/icons/products/web/menBluze.svg`),
    menCoat: require(`../../resources/icons/products/web/menCoat.svg`),
    menTrousers: require(`../../resources/icons/products/web/menTrousers.svg`),
    menTshirt: require(`../../resources/icons/products/web/menTshirt.svg`),
    womenCover: require(`../../resources/icons/products/web/womenCover.svg`),
    menShortTrousers: require(`../../resources/icons/products/web/menShortTrousers.svg`),
    menTie: require(`../../resources/icons/products/web/menTie.svg`),
    womenCoat: require(`../../resources/icons/products/web/womenCoat.svg`),
    womenDress: require(`../../resources/icons/products/web/womenDress.svg`),
    womenCeremonyDress: require(`../../resources/icons/products/web/womenCeremonyDress.svg`),
    womenTrousers: require(`../../resources/icons/products/web/womenTrousers.svg`),
    womenWeddingDress: require(`../../resources/icons/products/web/womenWeddingDress.svg`),
    womenMantoo: require(`../../resources/icons/products/web/womenMantoo.svg`),
    ceremonyMantoo: require(`../../resources/icons/products/web/ceremonyMantoo.svg`),
    womenSkirt: require(`../../resources/icons/products/web/womenSkirt.svg`),
    womenTshirt: require(`../../resources/icons/products/web/womenTshirt.svg`),
    womenHijab: require(`../../resources/icons/products/web/womenHijab.svg`),
    womenShortTrousers: require(`../../resources/icons/products/web/womenShortTrousers.svg`),
    womenLongHijab: require(`../../resources/icons/products/web/womenLongHijab.svg`),
    womenCoatTrousers: require(`../../resources/icons/products/web/womenCoatTrousers.svg`),
    menCoatWest: require(`../../resources/icons/products/web/menCoatWest.svg`),
    womenCoatSkirt: require(`../../resources/icons/products/web/womenCoatSkirt.svg`),
    menCoatTrousers: require(`../../resources/icons/products/web/menCoatTrousers.svg`),
    womenShomizSkirt: require(`../../resources/icons/products/web/womenShomizSkirt.svg`),
    womenShomizTop: require(`../../resources/icons/products/web/womenShomizTop.svg`),
    womenWinterClothes: require(`../../resources/icons/products/web/womenWinterClothes.svg`),
    orderBasket: require(`../../resources/icons/orderBasket.svg`),
    gift: require(`../../resources/gift.svg`),
    wallet: require(`../../resources/wallet.svg`),
    infoRounded: require(`../../resources/icons/infoRounded.svg`),
    logisticYellowRight: require(`../../resources/icons/logisticYellowRight.svg`),
    logisticOrangeRight: require(`../../resources/icons/logisticOrangeRight.svg`),
    logisticOrangeLeft: require(`../../resources/icons/logisticOrangeLeft.svg`),
    logisticRedRight: require(`../../resources/icons/logisticRedRight.svg`),
    washingMashin: require(`../../resources/icons/washingMashin.svg`),
    washingMashinYellow: require(`../../resources/icons/washingMashinYellow.svg`),
    washingMashinOrange: require(`../../resources/icons/washingMashinOrange.svg`),
    washingMashinGreen: require(`../../resources/icons/washingMashinGreen.svg`),
    logisticGray: require(`../../resources/icons/logisticGray.svg`),
    logisticGrayLeft: require(`../../resources/icons/logisticGrayLeft.svg`),
    logisticGreen: require(`../../resources/icons/logisticGreen.svg`),
    logisticGreenLeft: require(`../../resources/icons/logisticGreenLeft.svg`),
    logisticYellowLeft: require(`../../resources/icons/logisticYellowLeft.svg`),
    truck: require(`../../resources/icons/basket/web/truck.svg`),
    orderOnProgress: require(`../../resources/icons/orderOnProgress.svg`),
    ordersBasket: require(`../../resources/icons/basket/web/ordersBasket.svg`),
    receipt: require(`../../resources/icons/basket/web/receipt.svg`),
    personal: require(`../../resources/icons/personal.svg`),
    more: require(`../../resources/icons/more.svg`),
    delete: require(`../../resources/icons/delete.svg`),
    warning: require(`../../resources/icons/warning.svg`),
    emptyAddressesList: require(`../../resources/icons/emptyAddressesList.svg`),
    star: require(`../../resources/icons/star.svg`),
    warningGreen: require(`../../resources/icons/warningGreen.svg`),
    location: require(`../../resources/icons/profile/web/location.svg`),
    payment: require(`../../resources/icons/profile/web/payment.svg`),
    invitation: require(`../../resources/icons/profile/web/invitation.svg`),
    call: require(`../../resources/icons/profile/web/call.svg`),
    info: require(`../../resources/icons/profile/web/info.svg`),
    appVersion: require(`../../resources/icons/profile/web/appVersion.svg`),
    terms: require(`../../resources/icons/profile/web/terms.svg`),
    featured: require(`../../resources/icons/featured.svg`),
    dot: require(`../../resources/icons/dot.svg`),
    activeDot: require(`../../resources/icons/activeDot.svg`),
    logisticTime: require(`../../resources/icons/logisticTime.svg`),
    logOut: require(`../../resources/icons/profile/web/logOut.svg`),
    editPrice: require(`../../resources/icons/editPrice.svg`),
    play: require(`../../resources/icons/play.svg`),
    subtract: require(`../../resources/icons/subtract.svg`),
    appInfo: require(`../../resources/icons/appInfo.svg`),
    homeActive: require(`../../resources/icons/bottomNavigation/web/homeActive.svg`),
    ordersActive: require(`../../resources/icons/bottomNavigation/web/ordersActive.svg`),
    profileActive: require(`../../resources/icons/bottomNavigation/web/profileActive.svg`),
    homeDefault: require(`../../resources/icons/bottomNavigation/web/homeDefault.svg`),
    ordersDefault: require(`../../resources/icons/bottomNavigation/web/ordersDefault.svg`),
    profileDefault: require(`../../resources/icons/bottomNavigation/web/profileDefault.svg`),
    avatar: require(`../../resources/icons/avatar.svg`),
    sazmani: require(`../../resources/icons/categories/web/sazmani.svg`),
    shop: require(`../../resources/icons/products/web/shop.png`),
    shopIcon: require(`../../resources/icons/categories/web/shopIcon.png`),
  };
} else {
  pictures = {
    bed: require(`../../resources/icons/categories/android/bed.png`),
    children: require(`../../resources/icons/categories/android/children.png`),
    curtain: require(`../../resources/icons/categories/android/curtain.png`),
    home: require(`../../resources/icons/categories/android/home.png`),
    jackets: require(`../../resources/icons/categories/android/jackets.png`),
    men: require(`../../resources/icons/categories/android/men.png`),
    misc: require(`../../resources/icons/categories/android/misc.png`),
    shoes: require(`../../resources/icons/categories/android/shoes.png`),
    women: require(`../../resources/icons/categories/android/women.png`),
    wash: require(`../../resources/icons/products/android/wash.png`),
    iron: require(`../../resources/icons/products/android/iron.png`),
    stainRemover: require(`../../resources/icons/products/android/stainRemover.png`),
    tailoring: require(`../../resources/icons/tailoring.png`),
    minus: require(`../../resources/icons/products/android/minus.png`),
    minusDisabled: require(`../../resources/icons/products/android/minusDisabled.png`),
    add: require(`../../resources/icons/products/android/add.png`),
    addDisabled: require(`../../resources/icons/products/android/addDisabled.png`),
    serverError: require(`../../resources/icons/errors/android/serverError.png`),
    ordersEmpty: require(`../../resources/icons/errors/android/ordersEmpty.png`),
    gloves: require(`../../resources/icons/products/android/gloves.png`),
    hat: require(`../../resources/icons/products/android/hat.png`),
    socks: require(`../../resources/icons/products/android/socks.png`),
    shawl: require(`../../resources/icons/products/android/shawl.png`),
    pray: require(`../../resources/icons/products/android/pray.png`),
    cloak: require(`../../resources/icons/products/android/cloak.png`),
    canopy: require(`../../resources/icons/products/android/canopy.png`),
    carCover: require(`../../resources/icons/products/android/carCover.png`),
    childClothes: require(`../../resources/icons/products/android/childClothes.png`),
    doll: require(`../../resources/icons/products/android/doll.png`),
    babyShoes: require(`../../resources/icons/products/android/babyShoes.png`),
    carriage: require(`../../resources/icons/products/android/carriage.png`),
    babySeat: require(`../../resources/icons/products/android/babySeat.png`),
    babyClothes: require(`../../resources/icons/products/android/‌babyClothes.png`),
    skiJacket: require(`../../resources/icons/products/android/skiJacket.png`),
    jacket: require(`../../resources/icons/products/android/jacket.png`),
    coat: require(`../../resources/icons/products/android/coat.png`),
    featherJacket: require(`../../resources/icons/products/android/featherJacket.png`),
    overcoat: require(`../../resources/icons/products/android/overcoat.png`),
    skipants: require(`../../resources/icons/products/android/skipants.png`),
    rainCoat: require(`../../resources/icons/products/android/rainCoat.png`),
    pullOver: require(`../../resources/icons/products/android/pullOver.png`),
    sweatShirt: require(`../../resources/icons/products/android/sweatShirt.png`),
    cushion: require(`../../resources/icons/products/android/cushion.png`),
    carpet: require(`../../resources/icons/products/android/carpet.png`),
    lampshade: require(`../../resources/icons/products/android/lampshade.png`),
    tableclothes: require(`../../resources/icons/products/android/tableclothes.png`),
    mat: require(`../../resources/icons/products/android/mat.png`),
    mattress: require(`../../resources/icons/products/android/mattress.png`),
    blanket: require(`../../resources/icons/products/android/blanket.png`),
    cover: require(`../../resources/icons/products/android/cover.png`),
    eiderdown: require(`../../resources/icons/products/android/eiderdown.png`),
    pillow: require(`../../resources/icons/products/android/pillow.png`),
    pillowCover: require(`../../resources/icons/products/android/pillowCover.png`),
    bathrobes: require(`../../resources/icons/products/android/bathrobes.png`),
    sleepingBag: require(`../../resources/icons/products/android/sleepingBag.png`),
    towel: require(`../../resources/icons/products/android/towel.png`),
    shoes2: require(`../../resources/icons/products/android/shoes2.png`),
    semmershoes: require(`../../resources/icons/products/android/semmershoes.png`),
    boot: require(`../../resources/icons/products/android/boot.png`),
    leatherShoes: require(`../../resources/icons/products/android/leatherShoes.png`),
    backPack: require(`../../resources/icons/products/android/backPack.png`),
    bag: require(`../../resources/icons/products/android/bag.png`),
    loggage: require(`../../resources/icons/products/android/loggage.png`),
    menBluze: require(`../../resources/icons/products/android/menBluze.png`),
    menCoat: require(`../../resources/icons/products/android/menCoat.png`),
    menTrousers: require(`../../resources/icons/products/android/menTrousers.png`),
    menTshirt: require(`../../resources/icons/products/android/menTshirt.png`),
    womenCover: require(`../../resources/icons/products/android/womenCover.png`),
    menShortTrousers: require(`../../resources/icons/products/android/menShortTrousers.png`),
    menTie: require(`../../resources/icons/products/android/menTie.png`),
    womenCoat: require(`../../resources/icons/products/android/womenCoat.png`),
    womenDress: require(`../../resources/icons/products/android/womenDress.png`),
    womenCeremonyDress: require(`../../resources/icons/products/android/womenCeremonyDress.png`),
    womenTrousers: require(`../../resources/icons/products/android/womenTrousers.png`),
    womenWeddingDress: require(`../../resources/icons/products/android/womenWeddingDress.png`),
    womenMantoo: require(`../../resources/icons/products/android/womenMantoo.png`),
    ceremonyMantoo: require(`../../resources/icons/products/android/ceremonyMantoo.png`),
    womenSkirt: require(`../../resources/icons/products/android/womenSkirt.png`),
    womenTshirt: require(`../../resources/icons/products/android/womenTshirt.png`),
    womenHijab: require(`../../resources/icons/products/android/womenHijab.png`),
    womenShortTrousers: require(`../../resources/icons/products/android/womenShortTrousers.png`),
    womenLongHijab: require(`../../resources/icons/products/android/womenLongHijab.png`),
    womenCoatTrousers: require(`../../resources/icons/products/android/womenCoatTrousers.png`),
    menCoatWest: require(`../../resources/icons/products/android/menCoatWest.png`),
    womenCoatSkirt: require(`../../resources/icons/products/android/womenCoatSkirt.png`),
    menCoatTrousers: require(`../../resources/icons/products/android/menCoatTrousers.png`),
    womenShomizSkirt: require(`../../resources/icons/products/android/womenShomizSkirt.png`),
    womenShomizTop: require(`../../resources/icons/products/android/womenShomizTop.png`),
    womenWinterClothes: require(`../../resources/icons/products/android/womenWinterClothes.png`),
    orderBasket: require(`../../resources/icons/orderBasket.png`),
    gift: require(`../../resources/gift.png`),
    wallet: require(`../../resources/wallet.png`),
    infoRounded: require(`../../resources/icons/infoRounded.png`),
    logisticYellowRight: require(`../../resources/icons/logisticYellowRight.png`),
    logisticOrangeRight: require(`../../resources/icons/logisticOrangeRight.png`),
    logisticOrangeLeft: require(`../../resources/icons/logisticOrangeLeft.png`),
    logisticRedRight: require(`../../resources/icons/logisticRedRight.png`),
    logisticGray: require(`../../resources/icons/logisticGray.png`),
    logisticGrayLeft: require(`../../resources/icons/logisticGrayLeft.png`),
    logisticGreen: require(`../../resources/icons/logisticGreen.png`),
    logisticGreenLeft: require(`../../resources/icons/logisticGreenLeft.png`),
    logisticYellowLeft: require(`../../resources/icons/logisticYellowLeft.png`),
    washingMashin: require(`../../resources/icons/washingMashin.png`),
    washingMashinYellow: require(`../../resources/icons/washingMashinYellow.png`),
    washingMashinOrange: require(`../../resources/icons/washingMashinOrange.png`),
    washingMashinGreen: require(`../../resources/icons/washingMashinGreen.png`),
    truck: require(`../../resources/icons/basket/android/truck.png`),
    orderOnProgress: require(`../../resources/icons/orderOnProgress.png`),
    ordersBasket: require(`../../resources/icons/basket/android/ordersBasket.png`),
    receipt: require(`../../resources/icons/basket/android/receipt.png`),
    personal: require(`../../resources/icons/personal.png`),
    more: require(`../../resources/icons/more.png`),
    delete: require(`../../resources/icons/delete.png`),
    warning: require(`../../resources/icons/warning.png`),
    emptyAddressesList: require(`../../resources/icons/emptyAddressesList.png`),
    star: require(`../../resources/icons/star.png`),
    warningGreen: require(`../../resources/icons/warningGreen.png`),
    location: require(`../../resources/icons/profile/android/location.png`),
    payment: require(`../../resources/icons/profile/android/payment.png`),
    invitation: require(`../../resources/icons/profile/android/invitation.png`),
    call: require(`../../resources/icons/profile/android/call.png`),
    info: require(`../../resources/icons/profile/android/info.png`),
    appVersion: require(`../../resources/icons/profile/android/appVersion.png`),
    terms: require(`../../resources/icons/profile/android/terms.png`),
    featured: require(`../../resources/icons/featured.png`),
    dot: require(`../../resources/icons/dot.png`),
    activeDot: require(`../../resources/icons/activeDot.png`),
    logisticTime: require(`../../resources/icons/logisticTime.png`),
    logOut: require(`../../resources/icons/profile/android/logOut.png`),
    editPrice: require(`../../resources/icons/editPrice.png`),
    play: require(`../../resources/icons/play.png`),
    subtract: require(`../../resources/icons/subtract.png`),
    appInfo: require(`../../resources/icons/appInfo.png`),
    homeActive: require(`../../resources/icons/bottomNavigation/android/homeActive.png`),
    ordersActive: require(`../../resources/icons/bottomNavigation/android/ordersActive.png`),
    profileActive: require(`../../resources/icons/bottomNavigation/android/profileActive.png`),
    homeDefault: require(`../../resources/icons/bottomNavigation/android/homeDefault.png`),
    ordersDefault: require(`../../resources/icons/bottomNavigation/android/ordersDefault.png`),
    profileDefault: require(`../../resources/icons/bottomNavigation/android/profileDefault.png`),
    avatar: require(`../../resources/icons/avatar.png`),
    sazmani: require(`../../resources/icons/categories/android/sazmani.png`),
    shop: require(`../../resources/icons/products/android/shop.png`),
    shopIcon: require(`../../resources/icons/categories/android/shopIcon.png`),
  };
}

function crossPlatformIconImport() {
  let assets = pictures;

  return {
    bed: assets.bed.default ?? assets.bed,
    children: assets.children.default ?? assets.children,
    curtain: assets.curtain.default ?? assets.curtain,
    home: assets.home.default ?? assets.home,
    jackets: assets.jackets.default ?? assets.jackets,
    men: assets.men.default ?? assets.men,
    misc: assets.misc.default ?? assets.misc,
    shoes: assets.shoes.default ?? assets.shoes,
    women: assets.women.default ?? assets.women,
    wash: assets.wash.default ?? assets.wash,
    iron: assets.iron.default ?? assets.iron,
    stainRemover: assets.stainRemover.default ?? assets.stainRemover,
    tailoring: assets.tailoring.default ?? assets.tailoring,
    minus: assets.minus.default ?? assets.minus,
    minusDisabled: assets.minusDisabled.default ?? assets.minusDisabled,
    add: assets.add.default ?? assets.add,
    addDisabled: assets.addDisabled.default ?? assets.addDisabled,
    serverError: assets.serverError.default ?? assets.serverError,
    ordersEmpty: assets.ordersEmpty.default ?? assets.ordersEmpty,
    gloves: assets.gloves.default ?? assets.gloves,
    hat: assets.hat.default ?? assets.hat,
    socks: assets.socks.default ?? assets.socks,
    shawl: assets.shawl.default ?? assets.shawl,
    pray: assets.pray.default ?? assets.pray,
    cloak: assets.cloak.default ?? assets.cloak,
    canopy: assets.canopy.default ?? assets.canopy,
    carCover: assets.carCover.default ?? assets.carCover,
    childClothes: assets.childClothes.default ?? assets.childClothes,
    doll: assets.doll.default ?? assets.doll,
    babyShoes: assets.babyShoes.default ?? assets.babyShoes,
    carriage: assets.carriage.default ?? assets.carriage,
    babySeat: assets.babySeat.default ?? assets.babySeat,
    babyClothes: assets.babyClothes.default ?? assets.babyClothes,
    skiJacket: assets.skiJacket.default ?? assets.skiJacket,
    jacket: assets.jacket.default ?? assets.jacket,
    coat: assets.coat.default ?? assets.coat,
    featherJacket: assets.featherJacket.default ?? assets.featherJacket,
    overcoat: assets.overcoat.default ?? assets.overcoat,
    skipants: assets.skipants.default ?? assets.skipants,
    rainCoat: assets.rainCoat.default ?? assets.rainCoat,
    pullOver: assets.pullOver.default ?? assets.pullOver,
    sweatShirt: assets.sweatShirt.default ?? assets.sweatShirt,
    cushion: assets.cushion.default ?? assets.cushion,
    carpet: assets.carpet.default ?? assets.carpet,
    lampshade: assets.lampshade.default ?? assets.lampshade,
    tableclothes: assets.tableclothes.default ?? assets.tableclothes,
    mat: assets.mat.default ?? assets.mat,
    mattress: assets.mattress.default ?? assets.mattress,
    blanket: assets.blanket.default ?? assets.blanket,
    cover: assets.cover.default ?? assets.cover,
    eiderdown: assets.eiderdown.default ?? assets.eiderdown,
    pillow: assets.pillow.default ?? assets.pillow,
    pillowCover: assets.pillowCover.default ?? assets.pillowCover,
    bathrobes: assets.bathrobes.default ?? assets.bathrobes,
    sleepingBag: assets.sleepingBag.default ?? assets.sleepingBag,
    towel: assets.towel.default ?? assets.towel,
    shoes2: assets.shoes2.default ?? assets.shoes2,
    semmershoes: assets.semmershoes.default ?? assets.semmershoes,
    boot: assets.boot.default ?? assets.boot,
    leatherShoes: assets.leatherShoes.default ?? assets.leatherShoes,
    backPack: assets.backPack.default ?? assets.backPack,
    bag: assets.bag.default ?? assets.bag,
    loggage: assets.loggage.default ?? assets.loggage,
    menBluze: assets.menBluze.default ?? assets.menBluze,
    menCoat: assets.menCoat.default ?? assets.menCoat,
    menTrousers: assets.menTrousers.default ?? assets.menTrousers,
    menTshirt: assets.menTshirt.default ?? assets.menTshirt,
    womenCover: assets.womenCover.default ?? assets.womenCover,
    menShortTrousers:
      assets.menShortTrousers.default ?? assets.menShortTrousers,
    menTie: assets.menTie.default ?? assets.menTie,
    womenCoat: assets.womenCoat.default ?? assets.womenCoat,
    womenDress: assets.womenDress.default ?? assets.womenDress,
    womenCeremonyDress:
      assets.womenCeremonyDress.default ?? assets.womenCeremonyDress,
    womenTrousers: assets.womenTrousers.default ?? assets.womenTrousers,
    womenWeddingDress:
      assets.womenWeddingDress.default ?? assets.womenWeddingDress,
    womenMantoo: assets.womenMantoo.default ?? assets.womenMantoo,
    ceremonyMantoo: assets.ceremonyMantoo.default ?? assets.ceremonyMantoo,
    womenSkirt: assets.womenSkirt.default ?? assets.womenSkirt,
    womenTshirt: assets.womenTshirt.default ?? assets.womenTshirt,
    womenHijab: assets.womenHijab.default ?? assets.womenHijab,
    womenShortTrousers:
      assets.womenShortTrousers.default ?? assets.womenShortTrousers,
    womenLongHijab: assets.womenLongHijab.default ?? assets.womenLongHijab,
    orderBasket: assets.orderBasket.default ?? assets.orderBasket,
    womenCoatTrousers:
      assets.womenCoatTrousers.default ?? assets.womenCoatTrousers,
    menCoatWest: assets.menCoatWest.default ?? assets.menCoatWest,
    womenCoatSkirt: assets.womenCoatSkirt.default ?? assets.womenCoatSkirt,
    menCoatTrousers: assets.menCoatTrousers.default ?? assets.menCoatTrousers,
    womenShomizSkirt:
      assets.womenShomizSkirt.default ?? assets.womenShomizSkirt,
    womenShomizTop: assets.womenShomizTop.default ?? assets.womenShomizTop,
    womenWinterClothes:
      assets.womenWinterClothes.default ?? assets.womenWinterClothes,
    gift: assets.gift.default ?? assets.gift,
    wallet: assets.wallet.default ?? assets.wallet,
    infoRounded: assets.infoRounded.default ?? assets.infoRounded,
    logisticYellowRight:
      assets.logisticYellowRight.default ?? assets.logisticYellowRight,
    logisticOrangeRight:
      assets.logisticOrangeRight.default ?? assets.logisticOrangeRight,
    logisticOrangeLeft:
      assets.logisticOrangeLeft.default ?? assets.logisticOrangeLeft,
    logisticRedRight:
      assets.logisticRedRight.default ?? assets.logisticRedRight,
    washingMashin: assets.washingMashin.default ?? assets.washingMashin,
    washingMashinYellow:
      assets.washingMashinYellow.default ?? assets.washingMashinYellow,
    washingMashinOrange:
      assets.washingMashinOrange.default ?? assets.washingMashinOrange,
    washingMashinGreen:
      assets.washingMashinGreen.default ?? assets.washingMashinGreen,
    logisticGray: assets.logisticGray.default ?? assets.logisticGray,
    logisticGrayLeft:
      assets.logisticGrayLeft.default ?? assets.logisticGrayLeft,
    logisticGreen: assets.logisticGreen.default ?? assets.logisticGreen,
    logisticGreenLeft:
      assets.logisticGreenLeft.default ?? assets.logisticGreenLeft,
    logisticYellowLeft:
      assets.logisticYellowLeft.default ?? assets.logisticYellowLeft,
    truck: assets.truck.default ?? assets.truck,
    orderOnProgress: assets.orderOnProgress.default ?? assets.orderOnProgress,
    ordersBasket: assets.ordersBasket.default ?? assets.ordersBasket,
    receipt: assets.receipt.default ?? assets.receipt,
    personal: assets.personal.default ?? assets.personal,
    more: assets.more.default ?? assets.more,
    delete: assets.delete.default ?? assets.delete,
    warning: assets.warning.default ?? assets.warning,
    emptyAddressesList:
      assets.emptyAddressesList.default ?? assets.emptyAddressesList,
    star: assets.star.default ?? assets.star,
    warningGreen: assets.warningGreen.default ?? assets.warningGreen,
    location: assets.location.default ?? assets.location,
    payment: assets.payment.default ?? assets.payment,
    invitation: assets.invitation.default ?? assets.invitation,
    call: assets.call.default ?? assets.call,
    info: assets.info.default ?? assets.info,
    appVersion: assets.appVersion.default ?? assets.appVersion,
    terms: assets.terms.default ?? assets.terms,
    featured: assets.featured.default ?? assets.featured,
    dot: assets.dot.default ?? assets.dot,
    activeDot: assets.activeDot.default ?? assets.activeDot,
    logisticTime: assets.logisticTime.default ?? assets.logisticTime,
    logOut: assets.logOut.default ?? assets.logOut,
    editPrice: assets.editPrice.default ?? assets.editPrice,
    play: assets.play.default ?? assets.play,
    subtract: assets.subtract.default ?? assets.subtract,
    appInfo: assets.appInfo.default ?? assets.appInfo,
    homeActive: assets.homeActive.default ?? assets.homeActive,
    ordersActive: assets.ordersActive.default ?? assets.ordersActive,
    profileActive: assets.profileActive.default ?? assets.profileActive,
    homeDefault: assets.homeDefault.default ?? assets.homeDefault,
    ordersDefault: assets.ordersDefault.default ?? assets.ordersDefault,
    profileDefault: assets.profileDefault.default ?? assets.profileDefault,
    avatar: assets.avatar.default ?? assets.avatar,
    sazmani: assets.sazmani.default ?? assets.sazmani,
    shop: assets.shop.default ?? assets.shop,
    shopIcon: assets.shopIcon.default ?? assets.shopIcon,
  };
}

let iconsList = crossPlatformIconImport();

function CustomIcon(props) {
  const { icon, width, height } = props;

  if (icon) {
    return (
      <Image
        source={iconsList[icon]}
        style={{ width: width, height: height }}
      />
    );
  }
  return null;
}

export default CustomIcon;
